<script setup lang="ts">
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import AppShell from '@/layouts/AppShell.vue';
</script>

<template>
  <el-config-provider :locale="zhCn">
    <AppShell>
      <router-view />
    </AppShell>
  </el-config-provider>
</template>
